module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.influencerItems,
      "items-per-page": _vm.itemsPerPage,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instagramFullname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalFollowers))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.toPercent(item.audienceCredibility)) + " %\n            "), _c('v-icon', {
            attrs: {
              "color": _vm.getCredibilityColor(item.audienceCredibility)
            }
          }, [_vm._v("supervised_user_circle")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagementRate) + " %")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id ? 'Registered on IMS' : 'Unregistered'))]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.showReport(item)
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({}, on), [_vm._v("assessment")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.enterAmount(item, index)
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({}, on), [_vm._v("attach_money")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Enter payout amount")])])], 1)], 1)])
        }), 0)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  })], 1), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a6678d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InfluencerDataTable.vue
// module id = 2173
// module chunks = 0